export default __webpack_public_path__ + "static/media/005-about-noun_employees_2072725-1-1.c65e7fc1.webp";